import { Spinner } from '@cimplico/components';
import { Navigate, useParams } from 'react-router-dom';
import { useIsFirmRole } from '../hooks/use-is-firm-role';
import { useFirmContext } from '../providers/FirmProvider';
import { useGroup } from '../queries/use-group';
import PageContainer from '../components/page-container/PageContainer';
import PageTitle from '../components/PageTitle';
import EditGroupForm from '../features/edit-group/EditGroupForm';
import ErrorSplashScreen from './ErrorSplashScreen';

function EditGroupPage(): JSX.Element {
    const { id } = useParams();
    const { shortId } = useFirmContext();
    const { isExternalUser } = useIsFirmRole();
    const useGroupQuery = useGroup(id);

    if (isExternalUser) {
        return <Navigate to={`/${shortId}/groups`} />;
    }

    if (useGroupQuery.isLoading) {
        return (
            <div className="absolute w-full h-[var(--remaining-screen-height)]">
                <div className="absolute top-1/3 left-1/2">
                    <Spinner />
                </div>
            </div>
        );
    }

    if (useGroupQuery.isError || !useGroupQuery.isSuccess) {
        if (useGroupQuery.error?.response?.status === 404) {
            return (
                <ErrorSplashScreen
                    errorCode={404}
                    title="Group not found."
                    redirectTitle="Back to groups"
                    redirectUrl={`/${shortId}/groups`}
                    leftArrow={true}
                />
            );
        }
        return (
            <ErrorSplashScreen
                title="An error has occurred."
                redirectTitle="Back to groups"
                redirectUrl={`/${shortId}/groups`}
                leftArrow={true}
            />
        );
    }

    const group = useGroupQuery.data.group;

    return (
        <PageContainer>
            <div className="pb-4">
                <div className="pb-4 border-b">
                    <PageTitle title={`Edit ${useGroupQuery?.data?.group?.name}`} />
                </div>
                <div className="mx-auto w-full max-w-[450px] mt-8">
                    <EditGroupForm group={group} />
                </div>
            </div>
        </PageContainer>
    );
}
export default EditGroupPage;
